import * as Sentry from '@sentry/browser';

const isLocalDev = () => /^(localhost|127\.0\.0\.1|\[::1\])$/.test(window.location.hostname);

export const getSentry = (): typeof Sentry | undefined => {
  // Don't clutter up sentry logs with debug stuff
  if (isLocalDev()) {
    return undefined;
  }
  return Sentry;
};

export const initSentry = () => {
  // Don't clutter up sentry logs with debug stuff
  if (isLocalDev()) {
    return;
  }

  Sentry.init({
    dsn: 'https://11add88260eb59cf0cbb85440f74ca71@sentry.ameo.design/4',
    integrations: [],
  });
};

export const logError = (msg: string, err?: any) => {
  console.error(msg, err);
  const sentry = getSentry();
  if (sentry) {
    if (err) {
      sentry.captureException(err);
    } else {
      sentry.captureMessage(msg, 'error');
    }
  }
};
